import {
  call,
  delay,
  put,
  takeLatest,
  takeLeading,
} from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { devPortalBaseUrl } from "../../configuration/configuration"
import {
  fetchUserLoginStatus,
  updateHashNavigationTarget,
  updateSearchQuery,
} from "../../actions"
import { parseResponseData } from "../../utils/fetch-utils"

function createFailedRequestError(status, data) {
  const error = new Error(`Request failed with status ${status}`)
  error.response = {
    status,
    data,
  }
  return error
}

function* requestAndDispatchResult(url, actionType) {
  try {
    const response = yield call(fetch, url, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    })
    const data = yield call(parseResponseData, response)
    if (!response.ok) {
      throw createFailedRequestError(response.status, data)
    }
    yield put({
      type: `${actionType}_SUCCESS`,
      payload: {
        data,
      },
    })
  } catch (error) {
    yield put({
      type: `${actionType}_FAIL`,
      payload: error,
      error: true,
    })
  }
}

function* fetchUserLoginStatusSaga() {
  yield call(
    requestAndDispatchResult,
    `${devPortalBaseUrl}/user/api-docs-meta-data`,
    actionTypes.FETCH_USER_LOGIN_STATUS
  )
}

function* logoutFromDevPortalSaga() {
  yield call(
    requestAndDispatchResult,
    `${devPortalBaseUrl}/user/logout`,
    actionTypes.LOGOUT_FROM_DEV_PORTAL
  )
}

function* fetchUpdatedLoginStatus() {
  yield put(fetchUserLoginStatus())
}

function* updateHashWithDelay(action) {
  yield delay(200)
  yield put(updateHashNavigationTarget(action.hash))
}

function* updateSearchQueryWithDelay(action) {
  yield delay(action.delay)
  yield put(updateSearchQuery(action.query))
}

function* apiDocsSaga() {
  yield takeLatest(actionTypes.FETCH_USER_LOGIN_STATUS, fetchUserLoginStatusSaga)
  yield takeLatest(actionTypes.LOGOUT_FROM_DEV_PORTAL, logoutFromDevPortalSaga)
  yield takeLatest(
    `${actionTypes.LOGOUT_FROM_DEV_PORTAL}_SUCCESS`,
    fetchUpdatedLoginStatus
  )
  yield takeLatest(
    `${actionTypes.LOGOUT_FROM_DEV_PORTAL}_FAIL`,
    fetchUpdatedLoginStatus
  )
  yield takeLeading(actionTypes.SCHEDULE_HASH_NAVIGATION, updateHashWithDelay)
  yield takeLatest(
    actionTypes.SCHEDULE_UPDATE_SEARCH_QUERY,
    updateSearchQueryWithDelay
  )
}

export default apiDocsSaga
